//import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex'
import auth from './auth'

Vue.use(Vuex);

export const store = new Vuex.Store({

    state: {


    },

    getters: {



    },

    mutations: {




    },

    actions: {},

    modules: {

        auth

    }

})
